import React from 'react';
import { styled } from "../../../stitches.config";
import Box from '../Box'
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";
import Adslot from '../../Adslot';

export default props => {
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	const isDesktop = window.innerWidth >= 996;

	return (
		<Root className="b-2d-2m">
			<section className="container" data-tb-region={props.blockSettings.tb_region}>
				<Wrapper className="row" pcs={pcs}>
					<div className="col-xs-12 col-md-9">
						<WrapperContent>
							<Box {...props}
								id="b1"
								type={isDesktop ? "BPhotoOnTopLifestyle" : "BPhotoOnTop"}
								settings={props.settings.b1}
								imageHeight={(isDesktop ? 472 : null)}
							/>
							<Separator />
							<div className="background-color-wrapper">
								<Box {...props}
									id="b2"
									type={isDesktop ? "BPhotoOnTopLifestyle" : "BPhotoOnTop"}
									settings={props.settings.b2}
									imageHeight={(isDesktop ? 472 : null)}
								/>
							</div>
						</WrapperContent>
					</div>
					<div className="col-xs-12 col-md-3">
						{props.settings.b3?.title_normal && <Box {...props} id="b3" type="BPhotoOnTop" settings={props.settings.b3} />}

						<Reklama>
							<Adslot name={props.settings?.bAdslot?.name} width={300} />
						</Reklama>

						{props.settings.b4?.title_normal && <Box {...props} id="b4" type="BPhotoOnTop" settings={props.settings.b4} />}
					</div>
				</Wrapper>
			</section>
		</Root>
	);
}

const Root = styled("div", {
	"@bp4": {
		marginTop: "40px"
	}
})
const Separator = styled("div", {
	display: "none",
	width: "100%",
	height: "1px",
	backgroundColor: "#F5F5F5",
	marginBottom: "40px",
	"@bp4": {
		display: "block"
	}
});

const WrapperContent = styled("div", {
	maxWidth: "840px"
});

const Reklama = styled("div", {
	"@bp4": {
		margin: "0 0 24px 0"
	}
});